import { IApplicationState } from '../../types/redux';

export function getSuggestApiKey(state: IApplicationState) {
  return state.common.suggestApiKey;
}
